import { Project, Quote } from '../../services/openapi.types.generated';

export const getRoute = (data: Project | Quote): string => {
  return (
    (data.applicationId.startsWith('JB') && `/projects/${data.id}`) ||
    (data.applicationId.startsWith('OP') && 'activeQuote' in data && `/quotes/${data.activeQuote}/accept`) ||
    `/quotes/${data.id}/accept`
  );
};
